import { ChannelManager } from 'app/typings/channelManagers';

const CHANNEL_MANAGER_ORDER = [
  ChannelManager.D_EDGE,
  ChannelManager.SITEMINDER,
  ChannelManager.RESERVIT,
  ChannelManager.MEWS,
  ChannelManager.TRAVELCLICK,
  ChannelManager.CUBILIS,
  ChannelManager.ROOMCLOUD,
  ChannelManager.MISTER_BOOKING,
  ChannelManager.THAIS,
];

export const getSortedChannelManagersByImportance = (
  managers: ChannelManager[]
): ChannelManager[] => {
  return managers.sort(
    (a, b) =>
      CHANNEL_MANAGER_ORDER.indexOf(a) - CHANNEL_MANAGER_ORDER.indexOf(b)
  );
};
